// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const count_THANKS_VOTES = ["%(count)s po\u010fakovanie", "%(count)s po\u010fakovania", "%(count)s po\u010fakovan\u00ed"];
export const SAY_THANK_YOU = "Po\u010fakuj za sk\u00fasenos\u0165";
